import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "sonner";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const denied = user && user !== false && roles && roles.length && !roles.includes(user.role);

  useEffect(() => {
    if (denied) toast.error("You don't have access to that section.");
  }, [denied]);

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 rounded-full border-4 border-slate-200 border-t-navy-900 animate-spin" />
          <p className="text-sm text-slate-400">Loading Dermalis CRM…</p>
        </div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (denied) return <Navigate to="/" replace />;
  return children;
}
